<template>
    <v-sheet
        flat
        dark
        class="grey darken-4"
    >
        <v-container class="pt-8">
            <v-row>
                <v-col cols="12" md="6">
                    <v-card
                        flat
                        color="transparent"
                        width="100%"
                    >
                        <router-link to="/contact-us" class="text-decoration-none" style="color: white;">
                            <v-card-title class="text-h4 font-weight-light">Contact Us</v-card-title>
                        </router-link>
                        <v-card-subtitle class="grey--text text--lighten-1 text-body-1 font-weight-light">What would you like to inquire about?</v-card-subtitle>
                        <v-card-text class="grey--text text--lighten-1 text-body-1 font-weight-light">
                            Since we have various business operations in the US, please select the appropriate locations below.
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row class="flex-wrap flex-md-nowrap">
                <v-col
                    v-for="(location, i) in locations"
                    :key="i"
                    class="text-center"
                >
                    <h6 class="text-subtitle-2 text-uppercase">{{ location.name }}</h6>
                    <v-list-item three-line class="px-0">
                        <v-list-item-content>
                            <v-list-item-title>{{ location.address }}</v-list-item-title>
                            <v-list-item-subtitle>{{ location.cityStateZip }}</v-list-item-subtitle>
                            <v-list-item-subtitle>{{ location.phone }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
            </v-row>

            <v-row class="mt-10" justify="space-between">
                <div>
                    <v-btn
                        color="#1877F2"
                        text
                        icon
                        href="https://www.facebook.com/prospira.us"
                        target="_blank"
                    >
                        <v-icon>mdi-facebook</v-icon>
                    </v-btn>

                    <v-btn
                        color="#0a66c2"
                        text
                        icon
                        href="https://www.linkedin.com/company/bridgestone-apm-company/"
                        target="_blank"
                    >
                        <v-icon>mdi-linkedin</v-icon>
                    </v-btn>
                </div>

                <div class="d-flex justify-end pt-5 text-caption grey--text text--lighten-1">
                    &copy; {{ copyrightYear }} Prospira America Corporation
                </div>
            </v-row>
        </v-container>
    </v-sheet>
</template>

<script>
export default {
    name: 'FooterSection',

    data() {
        return {
            locations: [
                {
                    name: 'Corporate Headquarters',
                    address: '2030 Production Dr',
                    cityStateZip: 'Findlay, OH 45840',
                    phone: '(419) 423-9552'
                },

                {
                    name: 'Anti Vibration Division',
                    address: '235 Commerce Way',
                    cityStateZip: 'Upper Sandusky, OH 43351',
                    phone: '(419) 294-6989'
                }
            ],
            copyrightYear: new Date().getFullYear()
        }
    }
}
</script>